import i18next from "i18next";

import { createColumn } from "../../../../../../components/Table";
import { getWardLabel } from "../../../../../../utils/wardLabel";

export const manageStaffTableColumns = [
  createColumn({
    keyName: "name",
    header: () => i18next.t("settings_staff_columns_name"),
    cell: (info) => info.renderValue(),
    size: 180,
  }),
  createColumn({
    keyName: "email",
    header: () => i18next.t("settings_staff_columns_email"),
    cell: (info) => info.renderValue(),
    size: 200,
  }),
  createColumn({
    keyName: "isAdmin",
    header: () => i18next.t("settings_staff_columns_admin"),
    cell: (info) => i18next.t(info.getValue() ? "common_yes" : "common_no"),
    size: 60,
  }),
  createColumn({
    keyName: "isActive",
    header: () => i18next.t("settings_staff_columns_active"),
    cell: (info) => i18next.t(info.getValue() ? "common_yes" : "common_no"),
    size: 60,
  }),
  createColumn({
    keyName: "addedBy",
    header: () => i18next.t("settings_staff_columns_addedBy"),
    cell: (info) => info.renderValue(),
    size: 200,
  }),
  createColumn({
    keyName: "wards",
    header: () => getWardLabel().plural,
    cell: (info) => info.renderValue(),
    size: 60,
  }),
  createColumn({
    keyName: "action",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 26,
  }),
];
